// extracted by mini-css-extract-plugin
export default {"container":"aH7cr","textContainer":"DSO5e"};